<template>
  <v-tooltip top max-width="280px">
    <template v-slot:activator="{ on, attrs }">
      <v-progress-circular
        v-bind="attrs"
        size="16"
        width="2"
        indeterminate
        color="primary"
        class="core-recreating-progress-circular"
        v-on="on"
      ></v-progress-circular>
    </template>
    <span>{{ text || $t('views.common.tableCoreRecreating.text') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss">
.core-recreating-progress-circular {
  margin-bottom: 1px;
}
</style>
